import { createReducer } from '@reduxjs/toolkit';
import { clearAmountRemaining } from './order.action';
import { fetchAmountRemainingForPaymentPlanOrderThunk } from './order.thunk';
import { OrderState } from './order.types';

const initialState: OrderState = {
  amountRemaining: undefined,
  amountRemainingOrderId: undefined,
  amountRemainingByOrderId: {},
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(fetchAmountRemainingForPaymentPlanOrderThunk.fulfilled, (state, action) => {
      state.amountRemaining = action.payload;
      state.amountRemainingOrderId = action.meta.arg.orderId;
      state.amountRemainingByOrderId[action.meta.arg.orderId] = action.payload;
    })
    .addCase(clearAmountRemaining.type, (state) => {
      state.amountRemaining = undefined;
      state.amountRemainingOrderId = undefined;
      state.amountRemainingByOrderId = {};
    });
});
